'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'sailboat';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e445';
var svgPathData = 'M419 304L256 67.9 256 304 419 304zM224 336L70.4 336c-15.8 0-24.9-18.1-15.4-30.7L220.2 85.1c2.5-3.3 3.8-7.4 3.8-11.5l0-57.9C224 7 231 0 239.7 0l.1 0 .1 0c6.6 0 12.3 4 14.7 9.8L459.2 305.9c8.8 12.7-.3 30.1-15.8 30.1l-187.4 0 0 48 240 0c8.8 0 16 7.2 16 16 0 61.9-50.1 112-112 112l-288 0c-61.9 0-112-50.1-112-112 0-8.8 7.2-16 16-16l208 0 0-48zm0-32l0-170.7-128 170.7 128 0zM33.6 416c7.4 36.5 39.7 64 78.4 64l288 0c38.7 0 71-27.5 78.4-64L33.6 416z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSailboat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;